export const contactConstants = {
  ALL_ROLE_OPTIONS: [
    { value: '', label: 'All' },
    { value: 'building_manager', label: 'Building Manager' },
    { value: 'committee_member', label: 'Committee Member' },
    { value: 'managing_real_estate_agent', label: 'Real Estate Agent' },
    { value: 'guest', label: 'Guest' },
    { value: 'organisation_admin', label: 'Organisation Admin' },
    { value: 'owner_landlord', label: 'Owner Landlord' },
    { value: 'owner_occupier', label: 'Owner Occupier' },
    { value: 'strata_manager', label: 'Strata Manager' },
    { value: 'tenant', label: 'Tenant' },
  ],
};
